import { create } from 'zustand';

interface CustomersModal {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useCustomersModal = create<CustomersModal>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false })
}));
